const baseUserUrl = "User"
const baseContractUrl = "Contract"



  const endpoints = {
    getContractList:`${baseUserUrl}/GetUserCreatedContractList`,
    getContractDetails:`${baseContractUrl}`,
    addContract:`${baseContractUrl}`,
    editContract:`${baseContractUrl}`,
    deleteContract:`${baseContractUrl}`,
   

  };
  
  export default endpoints;
  